import { render, staticRenderFns } from "./Symptoms.vue?vue&type=template&id=62a0c445&scoped=true&"
import script from "./Symptoms.vue?vue&type=script&lang=js&"
export * from "./Symptoms.vue?vue&type=script&lang=js&"
import style0 from "./Symptoms.vue?vue&type=style&index=0&id=62a0c445&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a0c445",
  null
  
)

export default component.exports